import { useState } from 'react';
import { Box, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { MoreVertical, Pencil, Trash2 } from 'lucide-react';
import ContentReportModal from '@/modules/content/common/ContentReportModal';
import { TContentReportReason } from '@/types/Content.types';
import { extra } from '@/theme/colors/palettes';

// Overflow menu on a loop item. Authors can edit their own content; "Not interested"
// hard-drops an item from the requester's feeds on the next open.
const LoopOverflowMenu = ({
  onNotInterested,
  onReport,
  onEdit,
  onDelete,
  canReport = true,
  isOnDark = false,
}: {
  onNotInterested: () => void;
  onReport: (reason: TContentReportReason, note?: string) => Promise<void>;
  onEdit?: () => void;
  onDelete?: () => void;
  canReport?: boolean;
  isOnDark?: boolean;
}) => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  return (
    <>
      <Menu placement="bottom-end">
        <MenuButton
          as={Box}
          aria-label="More options"
          cursor="pointer"
          color={isOnDark ? 'whiteAlpha.900' : 'text.mediumBlue'}
          lineHeight={0}
          flexShrink={0}
          _hover={{ opacity: 0.7 }}
        >
          <MoreVertical size={16} />
        </MenuButton>
        <MenuList>
          {onEdit && (
            <MenuItem icon={<Pencil size={16} />} onClick={onEdit}>
              Edit content
            </MenuItem>
          )}
          {onDelete && (
            <MenuItem icon={<Trash2 size={16} />} color={extra.red} fontWeight={600} onClick={onDelete}>
              Delete content
            </MenuItem>
          )}
          {canReport && (
            <MenuItem style={{ color: extra.red, fontWeight: 600 }} onClick={() => setIsReportModalOpen(true)}>
              Report content
            </MenuItem>
          )}
          <MenuItem onClick={onNotInterested}>Not interested</MenuItem>
        </MenuList>
      </Menu>

      <ContentReportModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} onReport={onReport} />
    </>
  );
};

export default LoopOverflowMenu;
